import { CONTAINERS_GUI_FIELDS } from "./containers.settings";
import { TXGUISection } from "../../interfaces/gui/fields.interfaces";

const { "Thème & Couleurs": THEME, ...REST } = CONTAINERS_GUI_FIELDS;

export const X_STACK_GUI_FIELDS: TXGUISection = {
  "Thème & Couleurs": [
    ...(THEME ?? []),
    {
      type: "boxShadow",
      name: "boxShadow",
      label: "Ombre",
      placeholder: "0px 0px 5px 5px #000000",
    },
  ],
  "Arrière-plan": [
    { type: "image", name: "backgroundImage", label: "Image d'arriere plan" },
    {
      type: "toggle_option",
      name: "backgroundMode",
      label: "Mode de l'arriere plan",
      options: [
        { value: "CONTAINED", label: "Containeur" },
        { value: "FILL", label: "Remplir" },
      ],
      defaultValue: "CONTAINED",
    },
    {
      type: "toggle_option",
      name: "backgroundSize",
      label: "Taille de l'arriere plan",
      options: [
        { value: "cover", label: "Zoomer" },
        { value: "contain", label: "Ajuster" },
        { value: "fill", label: "Etirer" },
      ],
      defaultValue: "cover",
    },
    {
      type: "toggle_option",
      name: "backgroundAttachment",
      label: "Type de l'arriere plan",
      options: [
        { value: "scroll", label: "Normal" },
        { value: "fixed", label: "Figer" },
      ],
      defaultValue: "scroll",
    },
    {
      type: "select_option",
      name: "backgroundPosition",
      label: "Position de l'arriere plan",
      options: [
        { value: "top", label: "Haut" },
        { value: "top left", label: "Haut Gauche" },
        { value: "top right", label: "Haut Droite" },
        { value: "center", label: "Centrer" },
        { value: "bottom", label: "Bas" },
        { value: "bottom left", label: "Bas Gauche" },
        { value: "bottom right", label: "Bas Droite" },
        { value: "left", label: "Gauche" },
        { value: "right", label: "Droite" },
      ],
      defaultValue: "center",
    },
  ],
  Survolés: [
    {
      type: "color",
      name: "hoverBgColor",
      label: "Couleur d'arriere plan",
    },
    {
      type: "border",
      name: "hoverBorder",
      label: "Bordure",
      units: ["px", "em"],
    },
  ],
  ...REST,
};
